import { gql } from '@apollo/client';
const STRING_PAIR_FIELDS = gql`
  fragment StringPairFields on StringPairDto {
    key
    value
  }
`;
export const CONDITION_INSTANCE_FIELDS = gql`
  ${STRING_PAIR_FIELDS}
  fragment ConditionInstanceFields on ConfiguredConditionDto {
    id
    bean
    name
    parameters {
      ...StringPairFields
    }
  }
`;
export const CONDITION_FIELDS = gql`
  ${STRING_PAIR_FIELDS}
  fragment ConditionFields on ConfiguredConditionDto {
    id
    bean
    parameters {
      ...StringPairFields
    }
  }
`;
export const RULE_PARAMETER_TYPE_DTO = gql`
  ${STRING_PAIR_FIELDS}
  fragment RuleParameterTypeFields on RuleParameterTypeDto {
    name
    label
    description
    type
    options {
      ...StringPairFields
    }
    objectTypeId
  }
`;
export const CONDITION_TYPE_FIELDS = gql`
  ${RULE_PARAMETER_TYPE_DTO}
  fragment ConditionTypeFields on ConditionTypeDto {
    label
    description
    bean
    parameterTypes {
      ...RuleParameterTypeFields
    }
  }
`;